/*
 *   Copyright (c) 2025 Propally.Inc
 *   All rights reserved.
 */
import React from "react";
import { Dialog, DialogContent, DialogTitle, Typography, Box, IconButton } from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";

interface MaintenanceModalProps {
  open: boolean;
  onClose?: () => void;
}

export default function MaintenanceModal({ open, onClose }: MaintenanceModalProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      disableEscapeKeyDown
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: 2,
          padding: 2,
        },
      }}
    >
      <DialogTitle variant="h5" fontWeight="bold" sx={{ textAlign: "center", pb: 1 }}>
        サービスメンテナンス中
        {onClose && (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        )}
      </DialogTitle>
      <DialogContent>
        <Box sx={{ textAlign: "center", py: 2 }}>
          <Typography variant="body1" sx={{ mb: 2 }}>
            現在システムメンテナンスを行っております。
          </Typography>
          <Typography variant="body2" color="text.secondary">
            メンテナンス完了後にご利用ください。
            <br />
            ご迷惑をおかけして申し訳ございません。
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
